import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager } from 'ng-jhipster';

import { Feed } from './feed.model';
import { FeedPopupService } from './feed-popup.service';
import { FeedService } from './feed.service';

@Component({
    selector: 'dcs-feed-delete-dialog',
    templateUrl: './feed-delete-dialog.component.html'
})
export class FeedDeleteDialogComponent {

    feed: Feed;

    constructor(
        private feedService: FeedService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.feedService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'feedListModification',
                content: 'Deleted an feed'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'dcs-feed-delete-popup',
    template: ''
})
export class FeedDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private feedPopupService: FeedPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.feedPopupService
                .open(FeedDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed-delete-dialog.component.ts